<template>
  <generic-config 
    :values="getTransactionTypes"
    displayText="name"
    :onSaveHandler="onSave"
    :onDeleteHandler="onDelete"
    :leftPanelWidth="6"
    entityName="TransactionType"
    >
    <template v-slot:entryForm="{selectedItem, onSaveItem, onDeleteItem}">
      <MultipleEntries 
        :model="dataModel"
        :data="selectedItem"
        :mode="selectedItem ? 'viewEdit' : 'new'"
        @onSave="onSaveItem"
        @onDelete="onDeleteItem"
      />
    </template>
    <template v-slot:itemListing="{onItemSelected, values, displayText}">
      <item-list 
        title="" 
        :items="values" 
        :text="displayText" 
        :clickable="true" 
        @onClick="onItemSelected"/>
    </template>
  </generic-config>
</template>

<script>
import GenericConfig from "@/components/common/GenericConfig";
import ItemList from "@/components/common/ItemList";
import MultipleEntries from '@/components/common/MultipleEntries.vue';
import { TransactionType, uuid } from '@/model';

export default {
  components: {
    GenericConfig,
    MultipleEntries,
    ItemList
  },
  async created() {
    await this.$store.dispatch("getTransactionTypes");
  },
  data: () => ({
    dataModel : [
        {label: 'Uuid', valueAttr: 'uuid', type: 'text', display: false},
        {label: 'Name', valueAttr: 'name', type: 'text', display: true, required: true},
      ]
  }),
  computed: {
    transactionTypes() {
      const transactionTypes = this.$store.state.transactionTypes;
      return transactionTypes
        .map(cp => ({ 
          uuid: cp.uuid, 
          name: cp.name, 
          entries: cp.entries
            .map(ent => ({
                uuid: ent.uuid,
                account: ent.account.obj(),
                percentage: ent.percentage
            })
          )})
        );
    }
  },
  methods: {
    getTransactionTypes(cp) {
      if (!cp || !cp.uuid) {
        return this.transactionTypes;
      }
      return this.transactionTypes.filter(c => c.uuid !== cp.uuid);
    },
    toTransactionTypeJson(valueObject) {
      return  {
        uuid: valueObject.uuid || uuid(),
        name: valueObject.name,
        entries: valueObject.entries.map(entry => ({uuid: entry.uuid, account: entry.account.uuid, percentage: entry.percentage}))
      }
    },
    async onSave(valueObject) { 
      const transactionType = TransactionType.fromJson(this.toTransactionTypeJson(valueObject));
      await this.$store.dispatch("saveTransactionType", transactionType);
    },
    async onDelete([valueObject]) {
      const transactionType = TransactionType.fromJson(this.toTransactionTypeJson(valueObject));
      await this.$store.dispatch("deleteTransactionType", transactionType);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>